
import DATAMASTER from '../library/dataMaster'
import UMUM from '../library/umum'

export default {
  name: 'ApprovalDokumen',
  data() {
    return {
      filterku: {
        instansi: '',
        unit_kerja: '',
        tahun: new Date().getFullYear(),
        status_approval: '',
        menu_key: ''
      },

      cari_value: '',
      list_data: [],
      list_menu_options: [
        'BKU', 'DPA', 'LPJ', 'LRA', 'SPP', 'SPM', 'SP2D', 'REKON PAJAK', 'REKENING KORAN'
      ],

      selected_file: null,
      selected_file_type: '',
      selected_file_name: '',

      selected_data: null,
      mdl_approve: false,
      mdl_reject: false,
      catatan_revisi_input: '',

      DATAMASTER: DATAMASTER,
      UMUM: UMUM
    }
  },

  methods: {
    previewFile(data) {
      this.selected_file = data.file;
      this.selected_file_type = data.file_type || 'application/pdf';
      this.selected_file_name = data.nama_file;

      setTimeout(() => {
        window.scrollTo({ behavior: 'smooth', top: document.body.scrollHeight });
      }, 100);
    },

    downloadFile(filename) {
      window.open(this.$store.state.url.URL_APP + 'uploads/' + filename, '_blank');
    },

    selectData(data) {
      this.selected_data = data;
    },

    Notify(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: 'top',
        timeout: 1000
      });
    },

    async onChangexInstansi() {
      await DATAMASTER.getInstansiAsync("");
      this.onChangexUnitKerja();
    },

    async onChangexUnitKerja() {
      await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi);
      this.getView();
    },

    cari_data() {
      this.getView();
    },

    getView() {
      this.$store.commit("shoWLoading");
      const unitKerjaSearch = this.filterku.unit_kerja || this.filterku.instansi || '';

      fetch(this.$store.state.url.APPROVAL + 'list-dokumen', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'kikensbatara ' + localStorage.token
        },
        body: JSON.stringify({
          tahun: this.filterku.tahun,
          status_approval: this.filterku.status_approval,
          menu_key: this.filterku.menu_key,
          unit_kerja: unitKerjaSearch,
          cari: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          let rows = res_data.data || [];
          if (this.cari_value.trim()) {
            const q = this.cari_value.toLowerCase();
            rows = rows.filter(x => 
              (x.nama_file && x.nama_file.toLowerCase().includes(q)) ||
              (x.unit_kerja_nama && x.unit_kerja_nama.toLowerCase().includes(q))
            );
          }
          this.list_data = rows;
          this.$store.commit("hideLoading");
        })
        .catch(err => {
          console.error(err);
          this.$store.commit("hideLoading");
          this.Notify('Gagal memuat data', 'negative', 'warning');
        });
    },

    openRejectModal(data) {
      this.selected_data = data;
      this.catatan_revisi_input = '';
      this.mdl_reject = true;
    },

    submitApprove() {
      if (!this.selected_data) return;
      this.updateStatus(this.selected_data.table_name, this.selected_data.id, 1, null);
      this.mdl_approve = false;
    },

    submitReject() {
      if (!this.catatan_revisi_input.trim()) {
        this.Notify('Alasan penolakan wajib diisi!', 'warning', 'warning');
        return;
      }
      this.updateStatus(
        this.selected_data.table_name,
        this.selected_data.id,
        2,
        this.catatan_revisi_input
      );
      this.mdl_reject = false;
    },

    updateStatus(table_name, id, status_approval, catatan_revisi) {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.APPROVAL + 'verify-dokumen', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'kikensbatara ' + localStorage.token
        },
        body: JSON.stringify({
          table_name: table_name,
          id: id,
          status_approval: status_approval,
          catatan_revisi: catatan_revisi
        })
      })
        .then(res => res.json())
        .then(data => {
          this.$store.commit("hideLoading");
          this.Notify(
            data.message || 'Status berhasil diperbarui',
            status_approval === 1 ? 'primary' : 'negative',
            status_approval === 1 ? 'check_circle_outline' : 'warning'
          );
          this.getView();
        })
        .catch(err => {
          console.error(err);
          this.$store.commit("hideLoading");
          this.Notify('Gagal memverifikasi dokumen', 'negative', 'warning');
        });
    }
  },

  mounted() {
    let profilex = JSON.parse(localStorage.profile);
    let profile = profilex.profile;

    this.filterku.instansi = '';
    this.filterku.unit_kerja = '';

    if (this.$route.query.status_approval !== undefined && this.$route.query.status_approval !== null) {
      this.filterku.status_approval = this.$route.query.status_approval;
    }
    if (this.$route.query.tahun) {
      this.filterku.tahun = parseInt(this.$route.query.tahun);
    }

    DATAMASTER.getTahun();
    this.onChangexInstansi();
    this.getView();
  }
}
